module.exports = __webpack_public_path__ + "img/13_demontage_dattier_min.9e1fe63d.jpg";